import React, { useState, useEffect } from 'react';
import './Carousel.css';

const slides = [
  { id: 1, src: require('./images/image1Carousel.png'), alt: 'Imagen 1' },
  { id: 2, src: require('./images/image2Carousel.png'), alt: 'Imagen 2' },
  { id: 3, src: require('./images/image3Carousel.png'), alt: 'Imagen 3' },
  { id: 4, src: require('./images/image4Carousel.png'), alt: 'Imagen 4' },
  { id: 5, src: require('./images/image5Carousel.png'), alt: 'Imagen 5' },
];

const Carousel = () => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  // Carrusel activado - autoavance cada 3 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel" role="region" aria-label="Carrusel de imágenes">
      <button 
        className="carousel-btn left" 
        onClick={prevSlide}
        aria-label="Imagen anterior"
      >
        &lt;
      </button>
      <div className={`carousel-slide${current === 0 ? ' carousel-slide--first' : ''}`}>
        <img
          src={slides[current].src}
          alt={slides[current].alt}
          className={`carousel-img${current === 0 ? ' carousel-img--first' : ''}`}
          loading="lazy"
        />
      </div>
      <button 
        className="carousel-btn right" 
        onClick={nextSlide}
        aria-label="Imagen siguiente"
      >
        &gt;
      </button>
    </div>
  );
};

export default Carousel; 